/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


/* CHA cart upsell carousel controls */
(function () {
  'use strict';

  var version = 'v3';
  if (window.__chaRoutineGestures === version) return;
  window.__chaRoutineGestures = version;

  var drag = null;
  var suppressClickUntil = 0;
  var scrollFrames = new WeakMap();

  function railFrom(target) {
    return target && target.closest ? target.closest('.cha-routine__products') : null;
  }

  function cardsFor(rail) {
    return Array.prototype.slice.call(rail.querySelectorAll('[id^="cha-routine-card-"]'));
  }

  function cardLeft(card, firstCard) {
    return card.offsetLeft - firstCard.offsetLeft;
  }

  function nearestIndex(rail, cards) {
    if (!cards.length) return 0;
    var first = cards[0];
    var closestIndex = 0;
    var closestDistance = Infinity;
    cards.forEach(function (card, index) {
      var distance = Math.abs(cardLeft(card, first) - rail.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });
    return closestIndex;
  }

  function updateDots(rail, index) {
    var routine = rail.closest('.cha-routine');
    if (!routine) return;
    var dots = routine.querySelectorAll('.cha-routine__dots i');
    Array.prototype.forEach.call(dots, function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  }

  function goToCard(rail, index, smooth) {
    var cards = cardsFor(rail);
    if (!cards.length) return;
    var wrappedIndex = (index + cards.length) % cards.length;
    var left = cardLeft(cards[wrappedIndex], cards[0]);
    rail.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' });
    updateDots(rail, wrappedIndex);
  }

  document.addEventListener('click', function (event) {
    var previous = event.target.closest('[aria-label="Previous recommendation"]');
    var next = event.target.closest('[aria-label="Next recommendation"]');
    var control = previous || next;
    if (control) {
      var routine = control.closest('.cha-routine');
      var rail = routine && routine.querySelector('.cha-routine__products');
      if (!rail) return;
      event.preventDefault();
      goToCard(rail, nearestIndex(rail, cardsFor(rail)) + (next ? 1 : -1), true);
      return;
    }

    if (Date.now() < suppressClickUntil && railFrom(event.target)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('pointerdown', function (event) {
    var rail = railFrom(event.target);
    if (!rail || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
    if (event.target.closest('a, button, input, select, textarea, label')) return;
    var cards = cardsFor(rail);
    drag = {
      rail: rail,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startScroll: rail.scrollLeft,
      startIndex: nearestIndex(rail, cards),
      axis: null
    };
    rail.classList.add('is-dragging');
    try { rail.setPointerCapture(event.pointerId); } catch (error) {}
  }, true);

  document.addEventListener('pointermove', function (event) {
    if (!drag || drag.pointerId !== event.pointerId) return;
    var dx = event.clientX - drag.startX;
    var dy = event.clientY - drag.startY;
    if (!drag.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 7) {
      drag.axis = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'x' : 'y';
    }
    if (drag.axis !== 'x') return;
    event.preventDefault();
    drag.rail.scrollLeft = drag.startScroll - dx;
  }, { capture: true, passive: false });

  function finishDrag(event, cancelled) {
    if (!drag || (event && drag.pointerId !== event.pointerId)) return;
    var current = drag;
    drag = null;
    current.rail.classList.remove('is-dragging');
    if (current.axis !== 'x') return;
    var dx = event ? event.clientX - current.startX : 0;
    if (Math.abs(dx) > 28 && !cancelled) {
      goToCard(current.rail, current.startIndex + (dx < 0 ? 1 : -1), true);
    } else {
      goToCard(current.rail, nearestIndex(current.rail, cardsFor(current.rail)), true);
    }
    suppressClickUntil = Date.now() + 350;
  }

  document.addEventListener('pointerup', function (event) { finishDrag(event, false); }, true);
  document.addEventListener('pointercancel', function (event) { finishDrag(event, true); }, true);

  document.addEventListener('scroll', function (event) {
    var rail = event.target && event.target.matches && event.target.matches('.cha-routine__products') ? event.target : null;
    if (!rail) return;
    if (scrollFrames.has(rail)) cancelAnimationFrame(scrollFrames.get(rail));
    scrollFrames.set(rail, requestAnimationFrame(function () {
      updateDots(rail, nearestIndex(rail, cardsFor(rail)));
      scrollFrames.delete(rail);
    }));
  }, true);

  document.addEventListener('wheel', function (event) {
    var rail = railFrom(event.target);
    if (!rail) return;
    var horizontalIntent = Math.abs(event.deltaX) > Math.abs(event.deltaY);
    var shiftedWheel = event.shiftKey && Math.abs(event.deltaY) > Math.abs(event.deltaX);
    if (!horizontalIntent && !shiftedWheel) return;
    event.preventDefault();
    rail.scrollLeft += horizontalIntent ? event.deltaX : event.deltaY;
  }, { capture: true, passive: false });
})();
